import React from "react";
import { useEffect, useState } from "react";
import {
  Col,
  Button,
  FormGroup,
  Input,
  Card,
  CardHeader,
  CardBody,
} from "reactstrap";
import swal from "sweetalert";
import { mstrDataPartyReg } from "../../util/APIUtils";
import "react-datepicker/dist/react-datepicker.css";
import Papa from "papaparse";
import { LoadingOverlay } from "../../util/Helpers";

export default function MsPartyUpload() {
  const [block, setBlock] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  useEffect(() => { }, []);

  const handleUpload = (e) => {
    if (selectedFile) {
      setBlock(true);
      // This will log the JSON data from the Excel file
      Papa.parse(selectedFile, {
        header: true,
        dynamicTyping: true,
        complete: (result) => {
          mstrDataPartyReg(result.data)
            .then((response) => {
              setBlock(false);
              swal({
                text: "Purchase Registered successfully",
              });
              clearAll();
            })
            .catch((error) => {
              setBlock(false);
              clearAll();
              swal({
                text: "Unexpected error" + error,
              });
            });
        },
      });
    } else {
      swal({
        text: "Please select file",
      });
    }
  };

  const clearAll = () => {
    setSelectedFile(null);
    document.getElementById("file").value = "";
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.type === "text/csv") {
        setSelectedFile(file);
      } else {
        swal({
          text: "Please select valid CSV fie",
        });
        clearAll();
      }
    }
  };

  return (
    <div>
      {block && <LoadingOverlay />}
      <Card>
        <CardHeader className="carheaderSmall">
          <strong>Master Party Upload </strong>
        </CardHeader>
        <CardBody>
          <FormGroup row>
            <Col md="3">
              <label>Party Upload</label>
            </Col>
            <Col xs="12" md="6">
              <Input
                type="file"
                name="file"
                id="file"
                accept=".csv"
                onChange={handleFileChange}
              />
            </Col>
          </FormGroup>

          <FormGroup row>
            <Col md="3" />
            <Col md="3">
              <Button
                onClick={handleUpload}
                name="Submit"
                id="Submit"
                className="btn-info"
              >
                Submit
              </Button>
            </Col>
            <Col md="3">
              <Button
                onClick={clearAll}
                name="Submit"
                id="Submit"
                className="btn-warning"
              >
                Cancel
              </Button>
            </Col>
          </FormGroup>
        </CardBody>
      </Card>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/MsPartyUpload.js